export const ADD_ARTICLE = "ADD_ARTICLE";
export const UPDATE_TIME_SETTINGS = "UPDATE_TIME_SETTINGS";
export const UPDATE_ALL_COUNTRY_LIST = "UPDATE_ALL_COUNTRY_LIST";
export const UPDATE_FILTERED_COUNTRY_LIST = "UPDATE_FILTERED_COUNTRY_LIST";
export const ADD_FILTERED_COUNTRY_LIST = "ADD_FILTERED_COUNTRY_LIST";
export const REMOVE_FILTERED_COUNTRY_LIST = "REMOVE_FILTERED_COUNTRY_LIST";
export const UPDATE_TIME_SETTINGS_ONE_BY_ONE = "UPDATE_TIME_SETTINGS_ONE_BY_ONE";
export const UPDATE_CURRENT_RACE_TIME = "UPDATE_CURRENT_RACE_TIME";
export const UPDATE_T0_SETTINGS = "UPDATE_T0_SETTINGS";
export const RUNNERS_ODDS_AT_TIMES = "RUNNERS_ODDS_AT_TIMES";
export const IS_REFRESHED = "IS_REFRESHED";
export const UPDATE_EXACT_TIME_SETTINGS = "UPDATE_EXACT_TIME_SETTINGS";
export const UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE = "UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE";
export const UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE = "UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE";
export const UPDATE_LATEST_ODDS_SETTINGS = "UPDATE_LATEST_ODDS_SETTINGS";
export const UPDATE_COMMISSION_SETTINGS = "UPDATE_COMMISSION_SETTINGS";
export const UPDATE_BACK_STAKE_SETTINGS = "UPDATE_BACK_STAKE_SETTINGS";
export const UPDATE_LAY_STAKE_SETTINGS = "UPDATE_LAY_STAKE_SETTINGS";

//Selection state
export const SET_CUSTOM_SETTINGS_STATE = "SET_CUSTOM_SETTINGS_STATE";

//Steamers drifters settings 
export const STEAMER_MIN_PRICE = "STEAMER_MIN_PRICE";
export const STEAMER_MAX_PRICE = "STEAMER_MAX_PRICE";
export const DRIFTER_MIN_PRICE = "DRIFTER_MIN_PRICE";
export const DRIFTER_MAX_PRICE = "DRIFTER_MAX_PRICE";
export const MIN_VOLUME = "MIN_VOLUME";
export const UPDATE_STEAMER_DRIFTER_SETTINGS = "UPDATE_STEAMER_DRIFTER_SETTINGS";

//TimeOffset Settings
export const UPDATE_LOCAL_TIME_OFFSET_TO_GMT = "UPDATE_LOCAL_TIME_OFFSET_TO_GMT";
export const UPDATE_LOCAL_TIME_ZONE = "UPDATE_LOCAL_TIME_ZONE";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const UPDATE_DISPLAY_CONFIRM_NOX = "UPDATE_DISPLAY_CONFIRM_NOX";
export const UPDATE_BET_MARKET = "UPDATE_BET_MARKET";
